(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ljuva-collection"]) return;
  try {
    
  document.querySelectorAll('.lh-filter-panel').forEach(panel=>{if(matchMedia('(max-width:899px)').matches)panel.open=false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ljuva-header"]) return;
  try {
    
  function initLjuvaMenus(scope){scope.querySelectorAll('.lh-mega').forEach(menu=>{if(menu.dataset.ready)return;menu.dataset.ready='true';let closeTimer,openTimer;const open=()=>{clearTimeout(closeTimer);scope.querySelectorAll('.lh-mega').forEach(other=>{if(other!==menu)other.open=false;});menu.open=true;};menu.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(min-width:900px)').matches){clearTimeout(closeTimer);openTimer=setTimeout(open,120);}});menu.querySelector('summary').addEventListener('click',()=>clearTimeout(openTimer));menu.addEventListener('pointerleave',()=>{clearTimeout(openTimer);closeTimer=setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},180);});menu.addEventListener('toggle',()=>{if(menu.open)scope.querySelectorAll('.lh-mega').forEach(other=>{if(other!==menu)other.open=false;});});});}
  initLjuvaMenus(document);
  document.addEventListener('shopify:section:load',e=>initLjuvaMenus(e.target));
  document.addEventListener('click',e=>{if(!e.target.closest('.lh-header'))document.querySelectorAll('.lh-mega[open],.lh-mobile-menu[open]').forEach(m=>m.open=false);});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.lh-mega[open],.lh-mobile-menu[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ljuva-product"]) return;
  try {
    
  function initLjuvaProduct(root) {
    if(root.dataset.lhReady)return;
    root.dataset.lhReady='true';
    const main=root.querySelector('.lh-gallery__main'),zoom=root.querySelector('.lh-gallery__zoom');
    function image(src,alt){if(!main||!src)return;main.removeAttribute('srcset');main.src=src;if(alt)main.alt=alt;if(zoom)zoom.href=src;}
    root.querySelectorAll('[data-lh-image].lh-gallery__thumb').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();image(a.dataset.lhImage,a.dataset.lhAlt);root.querySelectorAll('.lh-gallery__thumb').forEach(x=>x.removeAttribute('aria-current'));a.setAttribute('aria-current','true');}));
    root.querySelectorAll('input[name="id"]').forEach(r=>r.addEventListener('change',()=>{root.querySelector('[data-lh-price]').textContent=r.dataset.lhPrice;const b=root.querySelector('[data-lh-add]'),available=r.dataset.lhAvailable==='true';b.disabled=!available;b.textContent=available?b.dataset.lhReady:b.dataset.lhUnavailable;image(r.dataset.lhImage);const sizePhoto=root.querySelector('[data-lh-size-preview]');if(sizePhoto)sizePhoto.src=r.dataset.lhSizeImage;const sizeLabel=root.querySelector('[data-lh-size-label]');if(sizeLabel)sizeLabel.textContent=r.dataset.lhSizeTitle;const u=new URL(location.href);u.searchParams.set('variant',r.value);history.replaceState({},'',u);}));
  }
  document.querySelectorAll('.lh-product').forEach(initLjuvaProduct);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.lh-product').forEach(initLjuvaProduct));

  } catch(e) { console.error(e); }
})();
})();
